export enum PersonalizationSwapTagsMode {
    NONE = 'NONE',
    VALUE = 'VALUE',
    FALLBACK = 'FALLBACK',
}

export enum PersonalizationTagTypes {
    DEFAULT = 'DEFAULT',
    CUSTOM = 'CUSTOM',
    ONETIME = 'ONETIME',
};

export interface IPersonalizationTag {
    tag: string,
    value: string | null,
    fallback: string,
}

export interface IPersonalizationTagDBContent {
    fallback: string;
    sample: string;
    isEnabled: boolean;
}

export interface IPersonalizationTagDB {
    [name: string]: IPersonalizationTagDBContent;
}

export interface IPersonalizationTagsDB {
    defaultTags?: IPersonalizationTagDB;
}

export interface IPersonalizationReviewTag {
    fallback: string;
    missingData: string[];
}

export interface IPersonalizationReview {
    [name: string]: IPersonalizationReviewTag;
}
